export default [
  {
    title: 'Admin.SideMenu.Management',
    icon: 'Clipboard',
    children: [
      {
        title: 'Admin.SideMenu.Navigation.Dashboard',
        route: 'admin-dashboard',
      },
      {
        title: 'Admin.SideMenu.Navigation.Prebid',
        route: 'admin-prebid',
      },
      {
        title: 'Admin.SideMenu.Navigation.ErrorDashboard',
        route: 'admin-errordashboard',
      },
      {
        title: 'Admin.SideMenu.Navigation.Accounts',
        route: 'admin-accounts',
      },
      {
        title: 'Admin.SideMenu.Navigation.Ads',
        route: 'admin-ads',
      },
      {
        title: 'Admin.SideMenu.Navigation.Transactions',
        route: 'admin-transactions',
      },
      {
        title: 'Admin.SideMenu.Navigation.Users',
        route: 'admin-users',
      },
      {
        title: 'Admin.SideMenu.Navigation.Withdraws',
        route: 'admin-withdraws',
      },
      {
        title: 'Admin.SideMenu.Navigation.Properties',
        route: 'admin-properties',
      },
      {
        title: 'Admin.SideMenu.Navigation.DailyCosts',
        route: 'admin-dailycosts',
      },
      {
        title: 'Admin.SideMenu.Navigation.PerformanceReport',
        route: 'admin-performance-report',
      },
      {
        title: 'Admin.SideMenu.Navigation.Whitelist/Blacklist',
        route: 'admin-whitelist-blacklist',
      },
    ],
  },
]
